import React, { useState, useEffect } from "react";
import { WEB_ROUTES } from "../routes/web-routes";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full flex justify-center z-50">
  <div className="bg-white shadow-lg rounded-lg p-6 mb-6 flex flex-col md:flex-row items-center w-full max-w-5xl mx-4">
        <p className="text-gray-700 text-sm flex-1 mb-4 md:mb-0 md:mr-4">
          We use cookies and web trackers to improve your online experience on our site, allow you to save information, provide social media features, customise the content and ads you see based on your interests. Cookies also help us understand how to use our site and improve its functionality. Please read our{' '}
          <a href={WEB_ROUTES.COOKIE_POLICY} className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">Cookie Policy here</a>.
          By closing the banner you allow the use of technical cookies only.
        </p>
        <button
          onClick={acceptCookies}
          className="bg-green-500 hover:bg-green-600 text-white font-semibold px-6 py-2 rounded shadow"
        >
          Accept
        </button>
      </div>
    </div>
  );
}
